import React from 'react';
import styled, { css } from 'styled-components';
import { RichH4, RichP1 } from '../Typography';
import { isFieldValid } from '../../utils/validation';
import media from '../../utils/media';
import { isLeftAligned } from '../../utils/variations';
const Container = styled.div `
  max-width: 300px;
  margin: 0px 0px 0px 30px;
  display: flex;
  flex-direction: column;
  justify-content: center;

  ${media.mobile} {
    margin: 0 auto;
    text-align: center;

    ${({ mobileAlignment }) => mobileAlignment &&
    isLeftAligned(mobileAlignment) &&
    css `
        margin: 0px 0px 30px 0px;
        text-align: start;
      `}
  }
`;
const Title = styled(RichH4) `
  margin-bottom: 10px;
`;
export const TextContainer = ({ bodyText, title, mobileAlignment }) => {
    return (React.createElement(Container, { className: "text-container", mobileAlignment: mobileAlignment },
        isFieldValid(title) && React.createElement(Title, { field: title }),
        isFieldValid(bodyText) && React.createElement(RichP1, { field: bodyText })));
};
